const BoxIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="15" height="15" rx="1.5" fill="#4318CD" stroke="#4318CD" />
            <path d="M12.35 5.15C12.15 4.95 11.85 4.95 11.65 5.15L6.5 10.3L4.35 8.15C4.15 7.95 3.85 7.95 3.65 8.15C3.45 8.35 3.45 8.65 3.65 8.85L6.15 11.35C6.25 11.45 6.35 11.5 6.5 11.5C6.65 11.5 6.75 11.45 6.85 11.35L12.35 5.85C12.55 5.65 12.55 5.35 12.35 5.15Z" fill="white" />
        </svg>
    );
}

export default BoxIcon;